import React from 'react';
import {
  DialogContent, IconButton, Stack, Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import StyledDialog from 'views/rebranded-module/common/components/UI/GalleryDialog/GalleryDialog.styles';
import { IsVideoOrImg } from 'views/rebranded-module/common/components/UI/IsVideoOrImg';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const responsive = {
  all: {
    breakpoint: { max: 4000, min: 0 },
    items: 1,
  },
};

const ArrowLeft = (arrowLeftProps) => (
  <span {...arrowLeftProps} className="GDArrow GDArrowLeft GGDialogIcon">
    <ArrowBackIcon />
  </span>
);

const ArrowRight = (arrowRightProps) => (
  <span {...arrowRightProps} className="GDArrow GDArrowRight GGDialogIcon">
    <ArrowForwardIcon />
  </span>
);

const GalleryDialog = ({
  open, onClose, mediaItems, currentIndex,
}) => (
  <StyledDialog fullScreen open={open} onClose={onClose}>
    <Stack alignItems="flex-end" mt={3} mx={3}>
      <IconButton onClick={onClose} className="GGDialogIcon">
        <CloseIcon />
      </IconButton>
    </Stack>

    <DialogContent className="GGDialogContent">
      <Carousel
        responsive={responsive}
        arrows
        infinite={false}
        showDots={false}
        ssr
        customTransition="all 0.3s ease"
        transitionDuration={300}
        containerClass="GDcarouselContainer"
        itemClass="GDCarouselItem"
        customLeftArrow={<ArrowLeft />}
        customRightArrow={<ArrowRight />}
        additionalTransfrom={0}
        partialVisible={false}
        centerMode={false}
        focusOnSelect={false}
        rewind={false}
        rewindWithAnimation={false}
        keyBoardControl
        renderDotsOutside={false}
        draggable
        swipeable
        removeArrowOnDeviceType={[]}
        customButtonGroup={null}
        deviceType="desktop"
        autoPlay={false}
        shouldResetAutoplay={false}
        slidesToSlide={1}
        initialSlide={currentIndex}>
        {mediaItems.map((slide) => (
          <Box
            key={slide.id || slide.url || slide.src}
            className="GDBoxWrapper">
            <IsVideoOrImg slide={slide} />
          </Box>
        ))}
      </Carousel>
    </DialogContent>
  </StyledDialog>
);

export { GalleryDialog };
